import styled from "styled-components";

export const GridStyled = styled.div`
	gap: 1em;
	display: flex;
	justify-content: center;
`;
